import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CommonForm from "./CommonForm";
import JoiningListComponent from "./JoiningListComponent";
import GmaeJoiningListComponent from "./GmaeJoiningListComponent";
import ListComponent from "./ListComponent";
import Setting from "./Setting";

export default function H5Games(props) {
  return (
    <>
    {/* <div className="d-flex flex-row"> */}
      
      <div className="flex-row-fluid" {...props}>
        <Switch>
          <Redirect
            from="/H5Games"
            exact={true}
            to="/H5Games/list"
          />
          <Route
            path="/H5Games/list"
            component={ListComponent}
          />
          <Route
            path="/H5Games/setting"
            component={Setting}
          />
          <Route
            path="/H5Games/create"   
            component={CommonForm}
          />
          <Route
            path="/H5Games/joining-list"
            component={JoiningListComponent}
          />
          <Route
            path="/H5Games/game-wise-joining-list"
            component={GmaeJoiningListComponent}
          />
          <Route
            path="/H5Games/edit/:id"
            component={CommonForm}
          />
        </Switch>
      </div>
    {/* </div> */}
    </>
  );
}
